/*
后台页面
*/
import admin from "@/views/admin/index"; //后台管理主页面
import adminDefault from "@/views/admin/default"; //admin默认页面
import login from "@/views/admin/login/login"; //后台管理登录页面
import setPassword from "@/views/admin/login/setPassword"; //后台管理设置密码页面

/*
系统管理
*/
import distributor from "../views/admin/system/distributor/distributor.vue"; //省级总代管理
import examlocation from "@/views/admin/system/examlocation/examlocation"; //市级管理
import userManagement from "@/views/admin/system/userManagement/userManagement"; //用户信息管理
import roleManagement from "@/views/admin/system/roleManagement/roleManagement"; //角色权限管理
import menuManagement from "@/views/admin/system/menuManagement/menuManagement"; //功能菜单管理
import registrationManagement from "@/views/admin/system/registrationManagement/registrationManagement"; //考点信息管理
import systemLog from "@/views/admin/system/systemLog/systemLog"; //系统日志管理
import payInfo from "@/views/admin/system/payInfo/payInfo"; //报名点支付信息管理
import infoService from "@/views/admin/system/infoService/infoService"; //信息服务管理

/*
基础信息管理
*/
import examsubject from "@/views/admin/information/examsubject/examsubject"; //考试科目维护
import studentinfo from "@/views/admin/information/studentinfo/studentinfo"; //考生信息管理
import judgesInfo from "@/views/admin/information/judgesInfo/judgesInfo"; //评委信息管理
import classSetting from "@/views/admin/information/classSetting/classSetting"; //试题分类管理
import theoryQuestionBank from "@/views/admin/information/theoryQuestionBank/theoryQuestionBank"; //理论考试题库
import theoryDetail from "@/views/admin/information/theoryQuestionBank/theoryDetail"; // 理论考试题详情
import examRoomManagement from "@/views/admin/information/examRoomManagement/examRoomManagement"; //考场信息管理
import teachingVideo from "@/views/admin/information/teachingVideo/teachingVideo"; // 教学视频管理
/*
考试信息管理
*/
import releaseExamInfo from "@/views/admin/examInfoManagement/releaseExamInfo/releaseExamInfo"; //发布考试信息

import registerExam from "@/views/admin/examInfoManagement/registerExam/registerExam"; //报名信息管理
import registerInfo from "@/views/admin/examInfoManagement/registerExam/registerInfo/registerInfo"; //考试名称报名详情
import testGroupPaper from "@/views/admin/examInfoManagement/registerExam/testGroupPaper/testGroupPaper"; //理论考试组卷
import formalExamination from "@/views/admin/examInfoManagement/registerExam/testGroupPaper/formalExamination"; // 理论考试 正式考试
import practiceTest from "@/views/admin/examInfoManagement/registerExam/testGroupPaper/practiceTest"; // 理论考试 模拟考试

import processManag from "@/views/admin/examInfoManagement/processManag/processManag"; //考试过程管理
import examInfo from "@/views/admin/examInfoManagement/processManag/examInfo"; //考试详情
import theoryInfo from "@/views/admin/examInfoManagement/processManag/theoryInfo"; //理论考试详情
import offExamInfo from "@/views/admin/examInfoManagement/processManag/OfflineExamInfo"; //线下考试详情
import studentExamPaper from "@/views/admin/examInfoManagement/processManag/studentExamPaper"; //查看试卷

import arrangeJudges from "@/views/admin/examInfoManagement/processManag/arrangeJudges"; //安排评委

import watchVideos from "@/views/admin/examInfoManagement/watchVideos/watchVideos"; //视频播放

import examArrangement from "@/views/admin/examInfoManagement/examArrangement/examArrangement"; //考试安排
import examArrangementInfo from "@/views/admin/examInfoManagement/examArrangement/examInfo"; //考试安排
/*
考试成绩管理
*/
import testScoreManag from "@/views/admin/testScoreManag/testScoreManag"; //考试成绩管理
/*
统计分析
*/
import statisticalAnalysis from "@/views/admin/statisticalAnalysis/statisticalAnalysis"; //统计分析
import examPointAnalysis from "@/views/admin/statisticalAnalysis/examPointAnalysis"; //考点运维数据分析
import comprehensive from "@/views/admin/statisticalAnalysis/comprehensive"; //统计分析
import dataReport from "@/views/admin/statisticalAnalysis/dataReport"; //数据可视化
/*
other
展示页面，无需权限
*/
import QRCode from "@/views/admin/components/QRCode"; //合格证查看
import AdCate from "@/views/admin/components/AdCate"; //准考证查看
import cert from "@/views/admin/components/cert"; //后台管理设置密码页面

/*
所有页面路由固定数据
meta：{
    title：//可供页面实时更新标签title
    isBavBread://控制页面上面包屑是否显示
    isShowInNavMenu//控制页面上菜单是否显示
    isShowGoBack:true,//控制页面面包屑右侧返回菜单是否显示
    parentsName:'processManag',//控制页面面包屑右侧返回菜单跳转的页面
}
*/
export const routes = [
  {
    path: "/",
    name: "default",
    redirect: "/login",
  },
  {
    path: "/admin",
    component: admin,
    name: "admin",
    meta: { title: "后台系统" },
    children: [
      {
        path: "",
        name: "default",
        component: adminDefault,
        meta: {
          title: "admin默认页面",
        },
      },
      {
        path: "/testScoreManag",
        component: testScoreManag,
        name: "testScoreManag",
        meta: { title: "考试成绩管理 ", isBavBread: true, isShowInNavMenu: true },
      },
      {
        path: "/comprehensive",
        component: comprehensive,
        name: "comprehensive",
        meta: { title: "综合查询 ", isBavBread: true, isShowInNavMenu: true },
      },
      {
        path: "/statisticalAnalysis",
        component: statisticalAnalysis,
        name: "statisticalAnalysis",
        meta: { title: "财务报表 ", isBavBread: true, isShowInNavMenu: true },
      },
      {
        path: "/examPointAnalysis",
        component: examPointAnalysis,
        name: "examPointAnalysis",
        meta: { title: "考点运维数据分析", isBavBread: true, isShowInNavMenu: true },
      },
      {
        path: "/dataReport",
        component: dataReport,
        name: "dataReport",
        meta: { title: "数据可视化", isBavBread: true, isShowInNavMenu: true },
      },
    ],
  },
  {
    path: "/system",
    name: "system",
    component: admin,
    redirect: "/system/distributor",
    meta: { title: "系统管理", isBavBread: true, isShowInNavMenu: true },
    children: [

      {
        path: "/system/userManagement",
        name: "userManagement",
        component: userManagement,
        meta: {
          title: "用户信息管理",
          isBavBread: true,
          isShowInNavMenu: true,
        },
      },
      {
        path: "/system/roleManagement",
        name: "roleManagement",
        component: roleManagement,
        meta: {
          title: "角色权限管理",
          isBavBread: true,
          isShowInNavMenu: true,
        },
      },
      {
        path: "/system/menuManagement",
        name: "menuManagement",
        component: menuManagement,
        meta: {
          title: "功能菜单管理",
          isBavBread: true,
          isShowInNavMenu: true,
        },
      },
      {
        path: "/system/systemLog",
        name: "systemLog",
        component: systemLog,
        meta: {
          title: "系统日志管理",
          isBavBread: true,
          isShowInNavMenu: true,
        },
      },
      {
        path: "/system/payInfo",
        name: "payInfo",
        component: payInfo,
        meta: {
          title: "报名点支付信息管理",
          isBavBread: true,
          isShowInNavMenu: true,
        },
      },
      {
        path: "/system/infoService",
        name: "infoService",
        component: infoService,
        meta: {
          title: "信息服务管理",
          isBavBread: true,
          isShowInNavMenu: true,
        },
      },

    ],
  },
  {
    path: "/information",
    name: "information",
    component: admin,
    redirect: "/information/examsubject",
    meta: { title: "基础信息管理", isBavBread: true, isShowInNavMenu: true },
    children: [
      {
        path: "/information/examsubject",
        name: "examsubject",
        component: examsubject,
        meta: {
          title: "考试科目维护",
          isBavBread: true,
          isShowInNavMenu: true,
        },
      },
      {
        path: "/information/studentinfo",
        name: "studentinfo",
        component: studentinfo,
        meta: {
          title: "考生信息管理",
          isBavBread: true,
          isShowInNavMenu: true,
        },
      },
      {
        path: "/information/judgesInfo",
        name: "judgesInfo",
        component: judgesInfo,
        meta: {
          title: "评委信息管理",
          isBavBread: true,
          isShowInNavMenu: true,
        },
      },
      {
        path: "/information/classSetting",
        name: "classSetting",
        component: classSetting,
        meta: {
          title: "试题分类管理",
          isBavBread: true,
          isShowInNavMenu: true,
        },
      },
      {
        path: "/information/theoryQuestionBank",
        name: "theoryQuestionBank",
        component: theoryQuestionBank,
        meta: {
          title: "理论考试题库",
          isBavBread: true,
          isShowInNavMenu: true,
        },
      },
      // {
      //   path: "/information/theoryQuestionBank",
      //   name: "theoryDetail",
      //   component: theoryDetail,
      //   meta: {
      //     alias: '/information/theoryQuestionBank?id=2',
      //     title: "理论考试题库详情",
      //     isBavBread: true,
      //     isShowInNavMenu: true,
      //     isShowGoBack: true,
      //     parentsName: 'theoryQuestionBank'
      //   },
      // },
      {
        path: "/information/distributor",
        name: "distributor",
        component: distributor,
        meta: {
          title: "省级总代管理",
          isBavBread: true,
          isShowInNavMenu: true,
        },
      },
      {
        path: "/information/examlocation",
        name: "examlocation",
        component: examlocation,
        meta: {
          title: "市级管理",
          isBavBread: true,
          isShowInNavMenu: true,
        },
      },
      {
        path: "/information/registrationManagement",
        name: "registrationManagement",
        component: registrationManagement,
        meta: {
          title: "考点信息管理",
          isBavBread: true,
          isShowInNavMenu: true,
        },
      },
      {
        path: "/information/examRoomManagement",
        name: "examRoomManagement",
        component: examRoomManagement,
        meta: {
          title: "考场信息管理",
          isBavBread: true,
          isShowInNavMenu: true,
        },
      },
      {
        path: "/information/teachingVideo",
        name: "teachingVideo",
        component: teachingVideo,
        meta: {
          title: "教学视频管理",
          isBavBread: true,
          isShowInNavMenu: true,
        },
      },
    ],
  },
  {
    path: "/examManag",
    name: "examManag",
    component: admin,
    redirect: "/examManag/releaseExamInfo",
    meta: { title: "考试信息管理", isBavBread: true, isShowInNavMenu: true },
    children: [
      {
        path: "/examManag/releaseExamInfo",
        name: "releaseExamInfo",
        component: releaseExamInfo,
        meta: {
          title: "发布考试信息",
          isBavBread: true,
          isShowInNavMenu: true,
        },
      },
      {
        path: "/examManag/registerExam",
        name: "registerExam",
        component: registerExam,
        meta: {
          title: "报名信息管理",
          isBavBread: true,
          isShowInNavMenu: true,
        },
        children: [
          {
            path: "registerInfo",
            name: "registerInfo",
            component: registerInfo,
            meta: {
              title: "考试名称报名详情",
              isBavBread: true,
              isShowGoBack: true,
              parentsName: "registerExam",
            },
          },
        ],
      },
      {
        path: "/examManag/testGroupPaper",
        name: "testGroupPaper",
        component: testGroupPaper,
        meta: {
          title: "理论考试组卷",
          isBavBread: true,
          isShowInNavMenu: true,
        },
        children: [
          {
            path: "formalExamination",
            name: "formalExamination",
            component: formalExamination,
            meta: {
              title: "组卷管理",
              isBavBread: true,
              isShowGoBack: true,
              parentsName: "testGroupPaper",
            },
          },
          {
            path: "practiceTest",
            name: "practiceTest",
            component: practiceTest,
            meta: {
              title: "组卷管理",
              isBavBread: true,
              isShowGoBack: true,
              parentsName: "testGroupPaper",
            },
          },
        ],
      },
      {
        path: "/examManage/videoReview",
        name: "videoReview",
        component: () => import('@/views/admin/examInfoManagement/videoReview/videoReview'),
        meta: {
          title: "考生视频审核",
          isBavBread: true,
          isShowInNavMenu: true,
        },
        children: [
          {
            path: "videoReviewInfo",
            name: "videoReviewInfo",
            component: () => import('@/views/admin/examInfoManagement/videoReview/videoReviewInfo'),
            meta: {
              title: "考生视频审核详情",
              isBavBread: true,
              isShowGoBack: true,
              parentsName: "videoReview",
            },
          },
        ],
      },
      {
        path: "/examManag/processManag",
        name: "processManag",
        component: processManag,
        meta: {
          title: "考试过程管理",
          isBavBread: true,
          isShowInNavMenu: true,
        },
        children: [
          {
            path: "examInfo",
            name: "examInfo",
            component: examInfo,
            meta: {
              title: "考试详情",
              isBavBread: true,
              isShowGoBack: true,
              parentsName: "processManag",
            },
          },
          {
            path: "theoryInfo",
            name: "theoryInfo",
            component: theoryInfo,
            meta: {
              title: "理论考试详情",
              isBavBread: true,
              isShowGoBack: true,
              parentsName: "processManag",
            }
          },
          {
            path: "studentExamPaper",
            name: "studentExamPaper",
            component: studentExamPaper,
            meta: {
              title: "查看试卷",
              isBavBread: true,
              isShowGoBack: true,
              parentsName: "theoryInfo",
            },
          },
          {
            path: "offExamInfo",
            name: "offExamInfo",
            component: offExamInfo,
            meta: {
              title: "线下考试详情",
              isBavBread: true,
              isShowGoBack: true,
              parentsName: "processManag",
            },
          },
          {
            path: "arrangeJudges",
            name: "arrangeJudges",
            component: arrangeJudges,
            meta: {
              title: "安排评委",
              isBavBread: true,
              isShowGoBack: true,
              parentsName: "processManag",
            },
          },
        ],
      },
      {
        path: "/examManag/examArrangement",
        name: "examArrangement",
        component: examArrangement,
        meta: {
          title: "线下考试安排",
          isBavBread: true,
          isShowInNavMenu: true,
        },
        children: [
          {
            path: "examArrangementInfo",
            name: "examArrangementInfo",
            component: examArrangementInfo,
            meta: {
              title: "考试详情",
              isBavBread: true,
              isShowGoBack: true,
              parentsName: "examArrangement",
            },
          },
        ],
      },
      {
        path: "/examManag/videos",
        name: "watchVideos",
        component: watchVideos,
        meta: {
          title: "视频播放功能",
          isBavBread: true,
          isShowInNavMenu: true,
        },
      },
    ],
  },
  {
    path: "/login",
    name: "login",
    component: login,
    meta: {
      title: "登录页",
    },
  },
  {
    path: "/setPassword",
    name: "setPassword",
    component: setPassword,
    meta: {
      title: "设置密码",
    },
  },
  {
    path: "/QRCode",
    name: "QRCode",
    component: QRCode,
    meta: {
      title: "合格证查看",
    },
  },
  {
    path: "/cert",
    name: "cert",
    component: cert,
    meta: {
      title: "证书查询",
    },
  },
  {
    path: "/AdCate",
    name: "AdCate",
    component: AdCate,
    meta: {
      title: "准考证查看",
    },
  },
];
